var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCollect = function SvgCollect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "url(#collect_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.812 8.315c.342-.821 1.505-.821 1.847 0l1.487 3.576a1 1 0 0 0 .843.613l3.86.309c.887.071 1.247 1.178.571 1.756l-2.94 2.52a1 1 0 0 0-.323.991l.899 3.767c.206.865-.735 1.549-1.494 1.085l-3.305-2.018a1 1 0 0 0-1.043 0l-3.304 2.018c-.76.464-1.7-.22-1.494-1.085l.898-3.767a1 1 0 0 0-.322-.991l-2.941-2.52c-.675-.579-.316-1.685.57-1.756l3.86-.31a1 1 0 0 0 .844-.612l1.487-3.576Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "collect_svg__a",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64DEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BC7A5"
  })))));
};

export default SvgCollect;